import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative flex items-center overflow-x-hidden',
    first: 'whitespace-nowrap',
    second: 'whitespace-nowrap'
  },
  variants: {
    active: {
      true: {
        first: 'animate-scrolling px-6',
        second: 'animate-scrolling2 absolute px-6'
      },
      false: {
        base: 'w-full justify-between',
        first: 'w-full justify-between px-0! [&>*:only-child]:mx-auto',
        second: 'hidden'
      }
    }
  },
  defaultVariants: {
    active: false
  }
});
